/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, object, optional, Schema, string } from '../schema';

export interface Address {
  country: string;
  addressLine: string[];
  addressType: string;
  streetName?: string;
  buildingNumber?: string;
  postCode: string;
  townName: string;
  countrySubDivision?: string;
}

export const addressSchema: Schema<Address> = object({
  country: ['Country', string()],
  addressLine: ['AddressLine', array(string())],
  addressType: ['AddressType', string()],
  streetName: ['StreetName', optional(string())],
  buildingNumber: ['BuildingNumber', optional(string())],
  postCode: ['PostCode', string()],
  townName: ['TownName', string()],
  countrySubDivision: ['CountrySubDivision', optional(string())],
});
